var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDealsIcon = function SvgDealsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.89 2.834c0-.523.42-.945.944-.945H8.98c.252 0 .492.099.67.276l8.187 8.188a.94.94 0 0 1 0 1.334l-6.145 6.149a.94.94 0 0 1-1.334 0L2.169 9.648a.94.94 0 0 1-.276-.669zM2.833 0A2.83 2.83 0 0 0 0 2.834V8.98c0 .752.3 1.472.83 2.004l8.188 8.187a2.834 2.834 0 0 0 4.008 0l6.144-6.144a2.834 2.834 0 0 0 0-4.008L10.983.831A2.83 2.83 0 0 0 8.979 0zM5.04 6.298a1.26 1.26 0 1 0 0-2.519 1.26 1.26 0 0 0 0 2.52"
  })));
};
export default SvgDealsIcon;